<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },
})
</script>

<template>
    <button
        :type="type"
        class="inline-flex items-center rounded-md border border-cyan-300 bg-cyan-100 px-4 py-2 text-xs font-semibold tracking-widest text-cyan-700 uppercase shadow-sm transition duration-150 ease-in-out hover:bg-cyan-50 focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 focus:outline-none disabled:opacity-25 dark:border-cyan-500 dark:bg-cyan-800 dark:text-cyan-300 dark:hover:bg-cyan-700 dark:focus:ring-offset-cyan-800"
    >
        <slot />
    </button>
</template>
